import { render, staticRenderFns } from "./ModalRetornarCotacaoBtn.vue?vue&type=template&id=005de016&scoped=true"
import script from "./ModalRetornarCotacaoBtn.vue?vue&type=script&lang=ts"
export * from "./ModalRetornarCotacaoBtn.vue?vue&type=script&lang=ts"
import style0 from "./ModalRetornarCotacaoBtn.vue?vue&type=style&index=0&id=005de016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005de016",
  null
  
)

export default component.exports